import { jwtDecode } from "jwt-decode";
import SessionStorage from "./SessionStorage.utils";

export const ADMIN_ROLE_MASTER = "MASTER";
export const ADMIN_ROLE_SUB = "SUB";

export const getAdminTokenPayload = () => {
  const adminSession = SessionStorage.getItemJsonParse("adminSession");

  if (!adminSession?.accessToken) return null;

  try {
    return jwtDecode(adminSession.accessToken);
  } catch (error) {
    return null;
  }
};

export const getAdminTokenPayloadFromToken = (accessToken) => {
  if (!accessToken) return null;

  try {
    return jwtDecode(accessToken);
  } catch (error) {
    return null;
  }
};

export const getAdminRole = () => {
  const payload = getAdminTokenPayload();
  return payload?.admin_role === ADMIN_ROLE_SUB ? ADMIN_ROLE_SUB : ADMIN_ROLE_MASTER;
};

export const isSubAdmin = () => getAdminRole() === ADMIN_ROLE_SUB;
export const isMasterAdmin = () => getAdminRole() === ADMIN_ROLE_MASTER;
